import { applyMiddleware, compose, createStore } from 'redux';
import promise from 'redux-promise';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { Iterable } from 'immutable';
import rootReducer from '.';
import businessMiddleware from './business/middleware';
import walletMiddleware from './wallet/middleware';
import campaignMiddleware from './campaign/middleware';
import userMiddleware from './user/middleware';
// eslint-disable-next-line no-redeclare
/* global LOGGER */

export default (history, initialState = {}) => {
  /* eslint-disable no-underscore-dangle */
  const composeEnhancers = ((process.env.NODE_ENV !== 'production' || LOGGER || window.CONFIG.DEBUG)
    && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true })) || compose;
  /* eslint-enable no-underscore-dangle */

  const middlewares = [thunk,
    promise,
    userMiddleware,
    businessMiddleware,
    walletMiddleware,
    campaignMiddleware,
    routerMiddleware(history)];

  if (LOGGER || window.CONFIG.DEBUG) {
    const logger = createLogger({
      stateTransformer: state => {
        const newState = {};

        for (const i of Object.keys(state)) { // eslint-disable-line
          if (Iterable.isIterable(state[i])) {
            newState[i] = state[i].toJS();
          } else {
            newState[i] = state[i];
          }
        }
        return newState;
      },
    });
    middlewares.push(logger);
  }
  const middleware = [
    applyMiddleware(...middlewares),
  ];

  const store = createStore(rootReducer(history), initialState, composeEnhancers(...middleware));

  window.store = store;
  return store;
};
